import './configstep.less'

import {Form, Formik} from 'formik'
import {RegistrationModel} from 'models/registration/RegistrationModel'
import {StepKey} from 'models/registration/StepModel'
import {
	ConfigureStepModel,
	ConfigureStepOptions
} from 'models/registration/steps/ConfigureStepModel'
import React from 'react'
import {useHistory} from 'react-router'
import {FormikChanges} from 'util/formikchanges'
import {style} from 'util/style'
import {Option} from 'views/registration/option'
import {Step} from 'views/registration/step'
import {Theme} from 'views/theme'

const styles = style('configstep')

export const ConfigStep: React.FC<{
	step: StepKey
	registration: RegistrationModel
	updateRegistration: (model: RegistrationModel) => void
}> = attrs => {
	const {registration, updateRegistration} = attrs
	const stepKey = attrs.step
	const step = registration.allSteps[stepKey] as ConfigureStepModel
	const history = useHistory()

	return (
		<Formik<ConfigureStepOptions>
			initialValues={step.state}
			onSubmit={values => {
				const newRegistration = step.setOptionsAndComments(
					registration.event.options,
					values
				)
				updateRegistration(newRegistration)
				if (step.isReady) {
					history.push(`#${step.nextStepKey}`)
				} else {
					// Scroll to first error
				}
			}}
		>
			<Form>
				<FormikChanges
					onChange={({values}) => {
						const newRegistration = step.setOptionsAndComments(
							registration.event.options,
							values
						)
						updateRegistration(newRegistration)
					}}
				/>
				<Step step={step} hasFormSubmit={true}>
					<div className={styles}>
						{step.options.map(option => {
							return (
								<>
									{option.descriptionAbove && (
										<div className={styles('info')}>
											<Theme.Wysiwyg>{option.descriptionAbove}</Theme.Wysiwyg>
										</div>
									)}
									<Option step={step} option={option} />
								</>
							)
						})}
					</div>
				</Step>
			</Form>
		</Formik>
	)
}
